import React from 'react';

export const EmailSignatureSelector = ({ value, onChange, disabled, loading, error, canApply }) => (
  <fieldset className="min-w-0 space-y-2 border-t border-gray-200 pt-2" data-testid="email-signature-section" disabled={disabled}>
    <legend className="text-sm font-medium text-gray-700 px-1">Sign off as</legend>
    <div className="flex min-w-0 items-start gap-2">
    <select
      aria-label="Email signature" value={value?.choice || ''}
      onChange={event => onChange({ ...value, choice: event.target.value })}
      data-testid="email-signature-select"
      className="min-w-0 flex-1 min-h-[44px] px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 disabled:opacity-60"
    >
      {!value && <option value="" disabled>Loading signature…</option>}
      <option value="team">The HOLONS Team</option>
      <option value="linda">Linda Serrano</option>
      <option value="custom">Custom name…</option>
    </select>
    {canApply && <button type="button" onClick={() => onChange(value)} disabled={loading || disabled}
      data-testid="email-signature-apply" title="Apply selected signature" aria-label="Apply selected signature"
      className="shrink-0 min-h-[44px] px-3 text-sm font-medium text-teal-700 border border-teal-300 rounded-lg hover:bg-teal-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-600 disabled:opacity-50 transition-colors">
      Apply
    </button>}
    </div>
    {value?.choice === 'custom' && (
      <div className="grid grid-cols-1 min-[360px]:grid-cols-2 gap-2">
        <label className="block min-w-0 text-sm text-gray-700">
          Name <span aria-hidden="true">*</span>
          <input
            type="text" required maxLength={80} value={value.custom_name || ''}
            onChange={event => onChange({ ...value, custom_name: event.target.value })}
            data-testid="email-signature-custom-name" autoComplete="off"
            className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500"
          />
        </label>
        <label className="block min-w-0 text-sm text-gray-700">
          Title (optional)
          <input
            type="text" maxLength={80} value={value.custom_title || ''}
            onChange={event => onChange({ ...value, custom_title: event.target.value })}
            data-testid="email-signature-custom-title" autoComplete="off"
            className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500"
          />
        </label>
      </div>
    )}
    {loading && <p className="text-xs text-teal-700" role="status" data-testid="email-signature-loading">Updating signature…</p>}
    {error && <p className="text-sm text-red-700" role="alert" data-testid="email-signature-error">{error}</p>}
  </fieldset>
);